import { fbt } from 'fbtee'
import { ChevronRight, MapPin } from 'lucide-react'
import { SettingsRow } from '../../components/SettingsCard'
import { RegionPicker } from '../../components/RegionPicker'
import { useHomeRegion } from '../../hooks/useHomeRegion'
import { regionLabel } from '../../lib/regionLabel'
import { LanguageSettingsRow } from './LanguageSettingsRow'
import { TimeFormatSettingsRow } from './TimeFormatSettingsRow'
import { WeekStartSettingsRow } from './WeekStartSettingsRow'
import { SettingsSection } from './SettingsSection'

export function PreferencesSection() {
  const { regionId, setRegion } = useHomeRegion()

  return (
    <SettingsSection title={fbt('Preferences', 'Settings section holding area, language, time format and week start')}>
      <RegionPicker regionId={regionId} onSelect={(id: string) => setRegion(id, 'settings')}>
        <SettingsRow
          icon={<MapPin className="size-4" />}
          label={<fbt desc="Row in Settings for choosing which area's events are shown">Area</fbt>}
          trailing={
            <span className="flex items-center gap-1.5 text-sm text-muted-foreground">
              {regionLabel(regionId)}
              <ChevronRight className="size-4" />
            </span>
          }
          onClick={() => {}}
        />
      </RegionPicker>
      <LanguageSettingsRow />
      <TimeFormatSettingsRow />
      <WeekStartSettingsRow />
    </SettingsSection>
  )
}
